/* eslint-disable camelcase */
export default class Mrp {
  item_master_id = 0;
  include_estimates = 1;
  description = 'Description';
  on_hand = 0;
  quarantine = 0;
  safety_stock = 0;
  assembly_level = 0;
  unit_of_measure = '';
  lead_time = '';
  part_number = '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Mrp.js